import BlazeSlider from 'blaze-slider'
import 'blaze-slider/dist/blaze.css'

const element = document.querySelector('.element-latestnews')

if (element) {
  const slider = element.querySelector('.blaze-slider')
  const numSlides = slider.querySelectorAll('.blaze-slide').length

  const handleControls = (el, numSlides) => {
    const controls = el.querySelector('.blaze-slider-controls')

    if (controls) {
      controls.classList.remove('invisible')

      if (window.matchMedia('(min-width: 1280px)').matches) {
        if (numSlides < 3) {
          controls.classList.add('invisible')
        }

        return
      }

      if (window.matchMedia('(min-width: 1024px)').matches) {
        if (numSlides < 2) {
          controls.classList.add('invisible')
        }

        return
      }

      if (window.matchMedia('(min-width: 768px)').matches) {
        if (numSlides <= 2) {
          controls.classList.add('invisible')
        }
      }
    }
  }

  if (numSlides > 1) {
    new BlazeSlider(slider, {
      '(min-width: 768px)': {
        slideGap: '20px',
      },
      '(min-width: 1280px)': {
        slideGap: '40px',
      },
    })

    handleControls(slider, numSlides)
  }
}
